"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadAllInvoices = exports.InvoiceActionType = void 0;
var _invoiceApi = require("../../../api-factory/invoiceApi");
var InvoiceActionType = exports.InvoiceActionType = /*#__PURE__*/function (InvoiceActionType) {
  InvoiceActionType["LOAD_ALL_INVOICES"] = "api/reducer/ALL_INVOICES";
  InvoiceActionType["LOADING"] = "api/reducer/LOADING";
  InvoiceActionType["HAS_API_ERROR"] = "api/reducer/HAS_API_ERROR";
  return InvoiceActionType;
}({});
var loadAllInvoices = exports.loadAllInvoices = function loadAllInvoices(dispatch, contractId) {
  dispatch({
    type: InvoiceActionType.LOADING
  });
  (0, _invoiceApi.getInvoices)(contractId).then(function (response) {
    dispatch({
      type: InvoiceActionType.LOAD_ALL_INVOICES,
      invoices: response.data.content
    });
  }).catch(function (error) {
    dispatch({
      type: InvoiceActionType.HAS_API_ERROR,
      apiErrorMessage: error.message
    });
  });
};